import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { debounce, Tooltip } from "@material-ui/core";
import { Link, useLocation, useHistory } from 'react-router-dom';
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import Moment from "moment";
import { Grid, Paper } from "@material-ui/core";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import CreateSalesOrder from "./CreateSalesOrder";
import moment from "moment";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
// import { makeStyles } from "@material-ui/core/styles";


const todate = new Date()
const Dfromdate = todate.getFullYear() + '/01/01';
const fromdate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate() - 60);

const SalesOrder = () => {
    // debugger;
    // const classes = useStyles();
    const [SalesOrderNo, setSalesOrderNo] = useState('');
    const [AccountID, setAccountID] = useState('');
    const [AccountName, setAccountName] = useState('');
    const [AccName, setAccName] = useState('');
    const [HandelBY, setHandelBY] = useState('');
    const [responseAccount, fetchAccountData] = UseFetchData();
    const [AccountOptions, setAccountOptions] = useState([]);
    const [Status, setStatus] = useState('');
    const [ModelNo, setModelNo] = useState('');
    const [City, setCity] = useState("");
    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [rows, setRows] = useState([]);
    const [Product, setProduct] = useState([]);
    const [ProductOptions, setProductOptions] = useState([]);
    const [ProductName, setProductName] = useState();
    const [responseProduct, fetchProductData] = UseFetchData();
    const [columns, setColumns] = useState([]);
    const [isOpen, setOpen] = useState(false);
    const [SalesOrderID, setSalesOrderID] = useState('');
    const [Count, setCount] = useState();
    const [ProductID, setProductID] = useState('');
    const [Mode, setMode] = useState('');
    const [ProductIDcmb, setProductIDcmb] = useState([]);
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [response, fetchData] = UseFetchData();
    const [SearchMode, setSearchMode] = useState("SEARCH");
    const [cmbLeadSourceData, setcmbLeadSourceData] = useState([]);
    const [cmbCountryData, setcmbCountryData] = useState([]);
    const [cmbCompanyData, setcmbCompanyData] = useState([]);
    const [cmbAccountData, setcmbAccountData] = useState([]);
    const [cmbPaymentTermsOptions, setcmbPaymentTermsOptions] = useState([]);
    const [flagSearch, setflagSearch] = useState(false);
    const location = useLocation();
    const [pageName, setPageName] = useState("SO");
    // var PN = location.state.pageName;
    const history = useHistory();
    var storedObject = "";
    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    const StatusOption = [
        { id: "Stage 1", title: "Stage 1" },
        { id: "Stage 2", title: "Stage 2" },
        { id: "Stage 3", title: "Stage 3" },
        { id: "Stage 4", title: "Stage 4" },
    ];

    const ProductData = () => {
        var bodyFormData = new FormData();
        fetchProductData("SalesOrder/ComboDataSO", bodyFormData);
    }

    const onProductChange = (event, newValue) => {
        // debugger;
        setProductName(newValue);
        setProductID(newValue.id)
    }

    const AccountData = () => {
        var bodyFormData = new FormData();
        fetchAccountData("SalesOrder/ComboDataSO", bodyFormData);
    }
    useEffect(() => {
        // debugger;
        if (responseProduct['cmbProduct'] !== undefined && responseProduct['cmbProduct'].length > 0) {
            // debugger;
            setProductOptions(responseProduct['cmbProduct']);
        }
        else {
            setProductOptions([]);
        }
    }, [responseProduct['cmbProduct']]);

    useEffect(() => {
        // debugger;
        if (responseAccount['cmbAccount'] !== undefined && responseAccount['cmbAccount'].length > 0) {
            setAccountOptions(responseAccount['cmbAccount']);
        }
        else {
            setAccountOptions([]);
        }
    }, [responseAccount['cmbAccount']]);


    // useEffect(() => {
    //     debugger;
    //     storedObject = sessionStorage.getItem('BCity');
    //     setCity(storedObject);

    // }, [storedObject]);


    useEffect(() => {
        // debugger;
        ProductData();
        AccountData();
        PopulateData();
    }, [])



    const PopulateData = (value) => {

        var bodyFormData = new FormData()
        var AccoName = "",
            AcName = null;
        if (AccountName !== undefined) {
            AccoName = AccountName.List;
        }

        // if (AccName !== "") {
        //     AcName = AccName;
        // }
        // if (storedObject != AccoName) {
        // }
        setSearchMode(SearchMode);
        bodyFormData.append("UserID", sessionStorage.UID);
        bodyFormData.append("UserType", sessionStorage.UserType);
        bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
        bodyFormData.append("UserType", sessionStorage.UserType);
        // if (value == "SEARCH") {
        //     bodyFormData.append("AccountName", AccoName);
        // }
        // else if (AccoName != "" && AccoName != undefined) {
        bodyFormData.append("AccountName", AccoName);
        // }
        // if (City == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        if (City == null && City == undefined) {
            var city = "";
            bodyFormData.append("City", city);
        }
        // else if (City == "" && City != "") {
        //     bodyFormData.append("City", City);
        //     GetValue(City)
        // }
        else {
            bodyFormData.append("City", City);
            // GetValue(City)
        }
        // }
        // else if (location.state.BCity != "" && location.state != undefined) {
        //     var Citi = location.state.BCity;
        //     bodyFormData.append("City", Citi);
        // }
        if (FromDate == undefined) {
            bodyFormData.append("FromDate", Moment(Dfromdate).format('YYYY-MM-DD'));
        }
        else {
            bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        }
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        // if (SalesOrderNo == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("SearchString", SalesOrderNo);
        // }
        // else if (location.state.Sno != "" && location.state != undefined) {
        //     var Sono = location.state.Sno;
        //     bodyFormData.append("SearchString", Sono);
        // }
        // if (ProductID == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("ProductID", ProductID);
        // }
        // else if (location.state.PID != "" && location.state != undefined) {
        //     var ProID = location.state.PID;
        //     bodyFormData.append("ProductID", ProID);
        // }
        // if (ModelNo == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("ModelCode", ModelNo);

        // }
        // else if (location.state.Mc != "" && location.state != undefined) {
        //     var MC = location.state.Mc;
        //     bodyFormData.append("ModelCode", MC);
        // }
        // event.preventDefault();
        // onBackButtonEvent();
        fetchData("SalesOrder/List", bodyFormData);

    };



    const handleOpenModal = () => {
        setSalesOrderID('');
        setMode('Insert');
        setOpen(true);
    };

    const onACCChange = (event, newValue) => {
        // debugger;
        setAccountName(newValue);
        setAccountID(newValue.id);
    }


    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: ".",
                renderCell: (params) => (<strong> <Link to={{ pathname: "/SalesOrder/SalesOrderView", state: { SalesOrderID: params.id, AccountName: AccountName.List, City, SalesOrderNo, ModelNo, ProductID, SearchMode } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,
            },
            {
                field: "SalesOrderNo",
                headerName: "SalesOrder No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "SalesOrderDate",
                headerName: "SalesOrder Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                valueFormatter: params =>
                    moment(params?.value).format("DD/MM/YYYY"),
            },
            {
                field: "QuotationNo",
                headerName: "Quotation No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "PONumber",
                headerName: "PO Ref",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "AccountName",
                headerName: "Account Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
                renderCell: (params) => (
                    <Tooltip title={params.row.AccountName} >
                        <span className="table-cell-trucate">{params.row.AccountName}</span>
                    </Tooltip>
                ),
                valueGetter: (params) => (params.value || "").toString().replace(/(\r\n|\n|\r)/gm, " "),
            },
            {
                field: "ContactName",
                headerName: "Contact Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "BillAddress1",
                headerName: "BillAddress 1",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                renderCell: (params) => (
                    <Tooltip title={params.row.BillAddress1} >
                        <span className="table-cell-trucate">{params.row.BillAddress1}</span>
                    </Tooltip>
                ),
                valueGetter: (params) => (params.value || "").toString().replace(/(\r\n|\n|\r)/gm, " "),
            },
            {
                field: "BillCountry",
                headerName: "Bill Country",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "BillStateName",
                headerName: "Bill State",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "CreatedBy",
                headerName: "Created By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "ModifiedBy",
                headerName: "Modified By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
        ];
        setColumns(gridCols);
        setRows(response);
        setCount(response.length);
    }, [response]);

    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ marginLeft: '93%' }}>
                <GridToolbarExport csvOptions={{
                    fields: ['SalesOrderNo', 'SalesOrderDate', 'QuotationNo', 'PONumber', 'AccountName', 'ContactName', 'BillAddress1', 'BillCountry', 'BillStateName', 'CreatedBy', 'ModifiedBy'],
                }} />
            </GridToolbarContainer>
        );
    }


    const getRowClassName = (params) => {
        // if (params.row.isCompleted) {
        //     return "completed-row";
        // }
        return 'Red';
    };

    const onSelectChange = (e) => {
        debugger;
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "City") {
                setCity(targetvalue);
            }
            if (targetname === "ModelNo") {
                setModelNo(targetvalue);
            }
            if (targetname === "SalesOrderNo") {
                setSalesOrderNo(targetvalue);
            }

        } else {
            if (targetname === "City") {
                setSalesOrderNo(targetvalue);
            }
            if (targetname === "ModelNo") {
                setSalesOrderNo(targetvalue);
            }
            if (targetname === "SalesOrderNo") {
                setSalesOrderNo(targetvalue);
            }
        }
    };

    return <div >
        <Grid container direction="row" style={{ marginTop: 10 }} >
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 0, paddingTop: 0, paddingBottom: 0, marginRight: 40 }}>
                <BiztranControls.Autocomplete
                    label="Product"
                    style={{ marginLeft: 8, width: "250px" }}
                    options={ProductOptions}
                    onChange={debounce(onProductChange, 300)}
                    value={Product}>
                </BiztranControls.Autocomplete>
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: -7 }} >
                <BiztranControls.Input
                    label="SalesOrder No"
                    id="SalesOrderNo"
                    // id={SalesOrderNo}
                    // name="SalesOrderNo"
                    style={{ width: 'maxWidth' }}
                    onChange={(e) => setSalesOrderNo(e.target.value)}
                // onChange={onSelectChange}
                />
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: -7 }}>
                <BiztranControls.Input
                    label="Model No"
                    id="ModelNo"
                    // value={ModelNo}
                    // name="ModelNo"
                    style={{ width: 'maxWidth' }}
                    onChange={(e) => setModelNo(e.target.value)}
                // onChange={onSelectChange}
                />
            </Grid>
            <Grid item xs={12} sm={4} md={2} lg={2} xl={2} style={{ marginTop: -7 }}>
                <BiztranControls.Input
                    label="City"
                    id="city"
                    // name="City"
                    //value not given try with value
                    style={{ width: 'maxWidth' }}
                    onChange={(e) => setCity(e.target.value)}
                // onChange={onSelectChange}
                />
            </Grid>
        </Grid>
        <Grid container direction="row" style={{ marginTop: 20 }}>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20, paddingTop: 0, paddingBottom: 0, marginRight: 40 }}>
                <BiztranControls.Autocomplete
                    label="Account Name"
                    options={AccountOptions}
                    style={{ marginLeft: 8, width: "250px" }}
                    onChange={onACCChange}
                    value={AccName}>
                </BiztranControls.Autocomplete>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={2} xl={2} style={{ marginLeft: 9 }}>
                <div style={{ width: "180px" }}>
                    <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setFromDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onFromClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultfromDate}
                    />
                </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                <div style={{ width: "180px", marginLeft: 6 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setToDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onToClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultToDate}
                    />
                </div>
            </Grid>
            <Grid xs={6} md={4} sm={8} lg={4} xl={3} >
                <div style={{ width: "100%", margin: 10 }} >
                    <div style={{ float: "left", width: "30%" }}>
                        <BiztranControls.Button
                            text="SEARCH"
                            startIcon={<SearchIcon />}
                            // style={{ marginTop: '16%' }}
                            onClick={() => {
                                PopulateData('SEARCH');
                                setflagSearch(true);
                            }}
                        />

                    </div>
                    <div style={{ float: "left", marginTop: 15, marginLeft: 5 }}>
                        <label style={{ fontWeight: 'bold', width: 10 }}>{Count}</label>
                    </div>
                    <div style={{ float: "left", paddingLeft: 10, width: "30%" }}>
                        <BiztranControls.Button
                            text="ADD NEW"
                            startIcon={<AddCircleOutlineIcon />}
                            // style={{ marginTop: '16%' }}
                            onClick={() => {
                                handleOpenModal();
                            }}
                        />
                    </div>
                </div>
            </Grid>
        </Grid>
        {/* <div classes={useStyles}> */}
        <BiztranControls.DataGrid
            headerHeight={34}
            rowHeight={25}
            rows={rows}
            columns={columns}
            checkboxSelection={false}
            getRowClassName={getRowClassName}
            // autoHeight={true}
            Height="500px"
            //Height="700px"
            Width="100%"
            components={{ Toolbar: CustomToolbar, }}
        />
        {/* </div> */}
        <ModalFrame
            title="SalesOrder Details"
            maxWidth="md"
            isOpen={isOpen}
            setOpen={setOpen}
        >
            <CreateSalesOrder
                Mode={Mode}
                setOpen={setOpen}
                PopulateData={PopulateData}
                cmbAccountData={cmbAccountData}
                cmbCompanyData={cmbCompanyData}
                cmbLeadSourceData={cmbLeadSourceData}
                cmbCountryData={cmbCountryData}
                cmbPaymentTermsOptions={cmbPaymentTermsOptions}
            />
        </ModalFrame>
    </div>;
};



// const useStyles = makeStyles((theme) => ({
//     Rowcolor: {
//         background: "#e6d8d8", //theme.palette.tertiary.gradient,
//         color: "#3d3d3d",

//     },

// }));
export default React.memo(SalesOrder);